import objectFitImages from 'object-fit-images'
import SmoothScroll from 'smooth-scroll'
import accordion from './lib/accordion'
import navigation from './lib/navigation'

import Vue from 'vue'
import Slick from 'vue-slick'



/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */

// objectFitImages -------------------------------------------------

objectFitImages()


// accordion -------------------------------------------------

accordion(300, '.accordion')



// SmoothScroll -------------------------------------------------

var scroll = new SmoothScroll('a[href*="#"]', {
  speedAsDuration: false,
  easing: 'Linear',
  updateURL: true,
});


/* -------------------------------------------------------------------
  navigation
------------------------------------------------------------------- */

navigation('header-navBtn', 'header')



/* -------------------------------------------------------------------
  mainimageSlider
------------------------------------------------------------------- */

if (document.getElementById('mainimageSlider')) {
  const mainimageSlider = new Vue({
    el: "#mainimageSlider",
    components: {
      Slick,
    },
    data() {
      return {
        slickOptions: {
          autoplay: true,
          arrows: false,
          infinite: true,
          dots: true,
          speed: 500,
          adaptiveHeight: true,
          centerMode: true,
          centerPadding: "15%",
          lazyLoad: 'progressive',
          responsive: [
            {
              breakpoint: 599,
              settings: {
                centerPadding: "5%",
              }
            },
          ]
        },
      }
    },
    mounted() {
    },
    methods: {
      next() {
        this.$refs.slick.next()
      },
      prev() {
        this.$refs.slick.prev()
      },
      reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
          this.$refs.slick.reSlick()
        })
      },
    },
  })
}



/* -------------------------------------------------------------------
  skiItemSlider
------------------------------------------------------------------- */

if (document.querySelector('.js-ski-item')) {
  document.querySelectorAll('.js-ski-item').forEach((el) => {
    new Vue({
      el: el,
      components: {
        Slick,
      },
      data() {
        return {
          slickOptions: {
            slidesToShow: 1,
            autoplay: true,
            arrows: false,
            infinite: true,
            dots: true,
            speed: 500,
            lazyLoad: 'progressive',
          },
        }
      },
      mounted() {
      },
      methods: {
        next() {
          this.$refs.slick.next()
        },
        prev() {
          this.$refs.slick.prev()
        },
        reInit() {
          // Helpful if you have to deal with v-for to update dynamic lists
          this.$nextTick(() => {
            this.$refs.slick.reSlick()
          })
        },
      },
    })
  })
}

